const LEVEL_MATERIAL_MAP = {
  xpBook1: 'wanderers_advice',
  xpBook2: 'adventurers_experience',
  xpBook3: 'heros_wit',
  cExp: 'c_exp'
}

export default LEVEL_MATERIAL_MAP;
